/** @deprecated Import deskGlass from styles/deskGlass.js — re-export for HomeShell compat. */
import deskGlass, { ACCENT } from "../../styles/deskGlass";

export const glassTheme = deskGlass;
export { ACCENT };
export default glassTheme;
